import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link2 } from "lucide-react";
import { http, errMsg } from "../lib/api";
import { Input } from "./ui/input";

export const ShopLinkCard = () => {
  const [pat, setPat] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { http.get("/settings/shop").then((r) => setPat(r.data.buy_pattern || "")); }, []);
  const save = async () => {
    setBusy(true);
    try { await http.put("/settings/shop", { buy_pattern: pat }); toast.success("Buy link pattern saved — every listing now gets a Buy button"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="shop-link-card" className="rounded-xl border border-stone-200 bg-white p-6">
      <div className="eyebrow flex items-center gap-2"><Link2 size={12} /> Automatic Buy links</div>
      <p className="text-xs text-stone-500 mt-3">Kits without their own Buy link use this pattern. <code className="text-[#9A7B2C]">{"{slug}"}</code> is replaced by each kit's web name. Leave blank to switch off.</p>
      <div className="flex gap-2 mt-3">
        <Input data-testid="shop-buy-pattern-input" value={pat} onChange={(e) => setPat(e.target.value)} placeholder="https://pbtravelangel.com/shop/{slug}" className="h-10 bg-[#F7F5F0] text-sm" />
        <button data-testid="shop-buy-pattern-save" onClick={save} disabled={busy} className="rounded-sm bg-[#2B2A26] px-4 text-sm font-bold text-white disabled:opacity-50">Save</button>
      </div>
      {pat.includes("{slug}") && <p className="text-[11px] text-stone-500 mt-2 break-all">Example: {pat.replace("{slug}", "hobart-tasmania-winter-solo-edition-mini-break")}</p>}
    </div>
  );
};
